import React from 'react';
import { Box, Button, Grid, Paper, Step, StepLabel, Stepper } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CancelIcon from '@mui/icons-material/Cancel';
import PublishIcon from '@mui/icons-material/Publish';
import FormPreviewPublication from './components/form-preview-publication';
import PreviewPublication from './components/preview-publication';
import { PUBLICATION_STEPS, useOfficialDiaryPublicationController } from './context/official-diary-publication-controller';
import { useOfficialDiaryPublicationState } from './context/official-diary-publication-context';
import PageHeader from '../../../components/page-header';

export function OfficialDiaryPublicationComponent() {
    const ctrl = useOfficialDiaryPublicationController();
    const { activeStep, files, lookups, previewPublicationRequest, previewPublicationResponse } = useOfficialDiaryPublicationState();

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Nova publicação"
                    subtitle="Preencha os dados, confira a prévia e publique no Diário Oficial"
                    breadcrumbs={[
                        { label: 'Diário Oficial', href: '/diario-oficial' },
                        { label: 'Nova publicação' }
                    ]}
                />
            </Grid>

            <Grid item xs={12}>
                <Paper sx={{ p: { xs: 2, md: 3 } }}>
                    <Stepper activeStep={activeStep} sx={{ mb: 4 }}>
                        {PUBLICATION_STEPS.map((label) => (
                            <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>

                    {ctrl.isLastStep ? (
                        <PreviewPublication previewPublicationResponse={previewPublicationResponse} />
                    ) : (
                        <FormPreviewPublication
                            request={previewPublicationRequest}
                            lookups={lookups}
                            errors={ctrl.validationErrors}
                            files={files}
                            onChange={ctrl.handleFieldChange}
                            onCategoryChange={ctrl.handleCategoryChange}
                            onClientChange={ctrl.handleClientChange}
                            setFilesUpload={ctrl.setFilesUpload}
                        />
                    )}

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, pt: 2, mt: 3, borderTop: '1px solid', borderColor: 'divider' }}>
                        <Button variant="outlined" startIcon={<CancelIcon />} onClick={ctrl.navigateBack}>Cancelar</Button>
                        <Box sx={{ flex: '1 1 auto' }} />
                        {ctrl.isLastStep && (
                            <Button variant="outlined" startIcon={<ArrowBackIcon />} onClick={ctrl.handleBack}>Anterior</Button>
                        )}
                        {ctrl.isLastStep ? (
                            <Button variant="contained" startIcon={<PublishIcon />} onClick={ctrl.handlePublish}>Publicar</Button>
                        ) : (
                            <Button variant="contained" endIcon={<ArrowForwardIcon />} onClick={ctrl.handleNext}>Próximo</Button>
                        )}
                    </Box>
                </Paper>
            </Grid>
        </React.Fragment>
    );
}
